module.exports = __webpack_public_path__ + "static/media/JPBA02.5385cb4c.jpg";